import { UNIT } from '../../../../../constant'
import { SET_DATA_KEY } from '../../constants'
import { omitObjectUtil } from 'packages/src'

export function updateWeightKeySetDataUtil (set, key) {
  if (key === SET_DATA_KEY.WEIGHT) {
    return {
      ...set,
      [key]: 10,
      [SET_DATA_KEY.WEIGHT_UNIT]: UNIT.IMPERIAL
    }
  }
  return omitObjectUtil(set, [
    SET_DATA_KEY.WEIGHT,
    SET_DATA_KEY.WEIGHT_UNIT
  ])
}
